module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet box blue-hoki"
  }, [_c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "tools clickable",
    on: {
      "click": function($event) {
        _vm.downloadCSV(_vm.itemSummary)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.itemSummary
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actual_price",
      "label": "Price",
      "width": "150",
      "formatter": _vm.tableFormatUSD,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_sale",
      "label": "Total sales",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_sku",
      "label": "SKU",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Category"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "tbl-category-column-wrapper"
        }, [_c('img', {
          staticClass: "tbl-category-image",
          attrs: {
            "src": scope.row.category_image
          }
        }), _vm._v(" "), _c('p', {
          staticClass: "tbl-category-name"
        }, [_vm._v(_vm._s(scope.row.category))])])]
      }
    }])
  })], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "fa-stack fa-sm"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x",
    staticStyle: {
      "color": "rgb(26,188,156)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trophy fa-stack-1x",
    staticStyle: {
      "color": "rgb(255,255,255)",
      "line-height": "inherit"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v("\n\t\t\t\t\t\tTop 10 Items\n\t\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb32480"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Analytics/ItemSales.vue
// module id = 678
// module chunks = 0